export default "__VITE_ASSET__CABslBaC__"